export enum RegistrationTypeEnum {
  CLASSIC = 'CLASSIC',
  CUSTOM = 'CUSTOM',
  NONE = 'NONE',
  FACEBOOK = 'FACEBOOK',
}
